import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {EulaData} from '@shared/services/eula.service';
import {HtmlSanitizerService} from '@core/services/html-sanitizer.service';

@Component({
    selector: 'oct-eula',
    templateUrl: './eula.component.html',
    styleUrls: ['./eula.component.scss']
})
export class EulaComponent implements OnInit {

    @Output() eulaAccepted = new EventEmitter<boolean>();

    acceptChecked: boolean = false;
    trustedHtmlContent: SafeHtml;

    constructor(
        private dialogRef: MatDialogRef<EulaComponent>,
        private sanitizer: DomSanitizer,
        private htmlSanitizer: HtmlSanitizerService,
        @Inject(MAT_DIALOG_DATA) public eulaData: EulaData
    ) {
    }

    ngOnInit(): void {
        this.trustedHtmlContent = this.htmlSanitizer.sanitizeHtml(this.eulaData.eula.text);
    }

    onSubmit() {
        this.dialogRef.close(true); // Close dialog with result true (accepted)
    }

    onDecline() {
        this.dialogRef.close(false); // Close dialog with result false (declined)
    }

    isAcceptChanged($event: any) {
        this.acceptChecked = $event.checked;
    }
}
